export default "__VITE_ASSET__CbHroTqW__"